
export function $httpProviderConfig ($httpProvider) {
  'ngInject';

  // CORS tweaks
  // $httpProvider.defaults.withCredentials = true;

  $httpProvider.defaults.cache = false;

  // initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }
  // disable IE ajax request caching
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
  $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';

}



// WEBPACK FOOTER //
// ./client/app/app.config/http.config.js